import React from "react";
import Select from "react-select";
import { glassSelectStyles } from "../../../constant/selectStyles";

const statusSelectOptions = [
  { value: "all", label: "All Statuses" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const FilterBar = ({
  chapterId,
  onChapterChange,
  status,
  onStatusChange,
  searchTerm,
  onSearchChange,
  chapterOptions = [],
}) => {
  const allChapterOptions = [
    { value: "all", label: "All chapters" },
    ...chapterOptions,
  ];

  const selectedChapterObj =
    allChapterOptions.find((opt) => String(opt.value) === String(chapterId)) ||
    allChapterOptions[0];

  const selectedStatusObj =
    statusSelectOptions.find((opt) => opt.value === status) ||
    statusSelectOptions[0];

  return (
    <div className="filter-card">
      <h6 className="filter-card-title">Search &amp; Filter</h6>

      <div className="row mb-4 gx-3">
        {/* Chapter dropdown */}
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="mb-3">
            <label className="filter-label" htmlFor="chapter_select">
              Chapter
            </label>
            <Select
              id="chapter_select"
              instanceId="cwm_chapter_select"
              menuPortalTarget={document.body}
              styles={glassSelectStyles}
              options={allChapterOptions}
              value={selectedChapterObj}
              onChange={(selected) =>
                onChapterChange(selected ? selected.value : "all")
              }
              isClearable={false}
            />
          </div>
        </div>

        {/* Status dropdown */}
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="mb-3">
            <label className="filter-label" htmlFor="status_select">
              Status
            </label>
            <Select
              id="status_select"
              instanceId="cwm_status_select"
              menuPortalTarget={document.body}
              styles={glassSelectStyles}
              options={statusSelectOptions}
              value={selectedStatusObj}
              onChange={(selected) =>
                onStatusChange(selected ? selected.value : "all")
              }
              isClearable={false}
            />
          </div>
        </div>

        {/* Search Category / Role */}
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="mb-3">
            <label className="filter-label" htmlFor="category_search">
              Category
            </label>
            <input
              id="category_search"
              type="text"
              className="form-control"
              placeholder="Search category..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
